import React from 'react';

interface YouTubeEmbedProps {
  url: string;
  height?: any;
}

export const YouTubeEmbed: React.FC<YouTubeEmbedProps> = ({ url, height = '400px' }) => {
  try {
    const urlObj = new URL(url);
    let videoId;

    // Preserve the original query parameters
    const searchParams = urlObj.search; 

    // Check if it's a `youtu.be` short link
    if (urlObj.hostname.includes("youtu.be")) {
      videoId = urlObj.pathname.substring(1);
    } 
    // Check if it's a standard YouTube video (`watch?v=XYZ`)
    else if (urlObj.hostname.includes("youtube.com") && urlObj.searchParams.has("v")) {
      videoId = urlObj.searchParams.get("v");
    } 
    // Check if it's a YouTube Shorts link (`youtube.com/shorts/XYZ`)
    else if (urlObj.hostname.includes("youtube.com") && urlObj.pathname.includes("/shorts/")) {
      videoId = urlObj.pathname.split("/shorts/")[1];
    }
    // *** NEW: Check if it's already an embed link (`youtube.com/embed/XYZ`) ***
    else if (urlObj.hostname.includes("youtube.com") && urlObj.pathname.includes("/embed/")) {
      videoId = urlObj.pathname.split("/embed/")[1];
    }

    if (!videoId) {
      return <div>Invalid YouTube URL</div>;
    }
    
    // Rebuild the URL but now include the original parameters
    const embedUrl = `https://www.youtube.com/embed/${videoId}${searchParams}`;

    return (
      <iframe
        width="100%"
        height={height}
        src={embedUrl}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    );
  } catch (error) {
    return <div>Invalid URL</div>;
  }
};

export default YouTubeEmbed;